import { render, staticRenderFns } from "./OrgAdminManageTeams.vue?vue&type=template&id=35565e90&scoped=true&"
import script from "./OrgAdminManageTeams.vue?vue&type=script&lang=ts&"
export * from "./OrgAdminManageTeams.vue?vue&type=script&lang=ts&"
import style0 from "./OrgAdminManageTeams.vue?vue&type=style&index=0&id=35565e90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35565e90",
  null
  
)

export default component.exports